import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class TermsService extends BaseService{
  getTermsPage(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`toc`)
        .subscribe(
            resp => {
               onSuccess(resp);
            },
            err => {
               if (onError) {
                   onError(err);
               }
            });
    }
}
